
let initialState = {
    webLinks: []
};

function webLinks(state = initialState, action) {

    if (action.type === "WEBLINK_ADD") {
        return {
            ...state,
            webLinks: state.webLinks.concat( action.webLink )
        }


    } else if (action.type === "WEBLINK_REMOVE"){
        return {
            ...state,
            webLinks: state.webLinks.filter(webLink => webLink.id !== action.id)
        }
    } else if (action.type === "WEBLINK_REMOVE_ALL"){
        return {
            ...state,
            webLinks: []
        }
    } else if (action.type === "WEBLINK_UPDATE"){
    
        const index = state.webLinks.findIndex(i => i.id === action.webLink.id)
        return {
            ...state,
            webLinks:[...state.webLinks.slice(0,index), 
                action.webLink,
                ...state.webLinks.slice(1+index)]

        }
    }

    return state;
}

export default webLinks;